<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">添加组织服务</div>
            <div class="page-back" @click="$router.go(-1)">返回</div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto"
                 class="flex flex-direction form margin-top">
            <el-form-item label="服务标题" prop="title">
                <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item ref="label" prop="label" label="服务标签">
                <el-tag
                        :key="tag"
                        v-for="tag in ruleForm.label"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
                <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">添加服务标签</el-button>
            </el-form-item>
            <el-form-item ref="desc" label="详细描述" class="margin-bottom-sm" prop="desc">
                <el-input v-model="ruleForm.desc" placeholder="请输入详细描述" type="textarea" resize="none"
                          :autosize="{ minRows: 6, maxRows: 6 }">
                </el-input>
            </el-form-item>
            <div class="service-list" v-for="(child, index) in ruleForm.childs" :key="index">
                <div class="item-title flex justify-between align-center margin-bottom-sm">
                    <div>服务项目{{index + 1}}</div>
                    <button class="padding-lr-xl operate" type="primary" v-if="index != 0" @click="delChild(index)">删除</button>
                </div>
                <el-form-item label="项目标题" :prop="'childs.' + index + '.title'"
                              :rules="{ required: true, message: '请输入服务项目标题', trigger: 'blur'}">
                    <el-input v-model="child.title" placeholder="请输入详细描述"></el-input>
                </el-form-item>
                <el-form-item label="详细描述" :prop="'childs.' + index + '.content'"
                              :rules="{ required: true, message: '请输入服务项目详细描述', trigger: 'blur'}">
                    <el-input v-model="child.content" placeholder="请输入服务项目详细描述"
                              type="textarea" resize="none" :autosize="{ minRows: 3, maxRows: 3 }"></el-input>
                </el-form-item>
            </div>
            <el-button style="width: 110px" class="margin-tb self-end" @click="addChild()">+ 添加项目
            </el-button>
            <el-button style="width: 220px" class="self-center" type="primary"
                       @click="submitForm('ruleForm')" :loading="loading">{{id ? '更新' : '发布'}}
            </el-button>
        </el-form>
    </div>
</template>

<script>

    import {getServerDetail,editServer} from '@/api/branch'
    export default {
        name: "serverEdit",
        data() {
            return {
                id: '',
                loading: false,
                ruleForm: {
                    title: '',
                    label: [],
                    desc: '',
                    childs: [{
                        id:'',
                        title: '',
                        content: ''
                    }]
                },
                rules: {
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'}
                    ],
                    label: [
                        {type: 'array', required: true, message: '请添加服务标签', trigger: 'blur'}
                    ],
                    desc: [
                        {required: true, message: '请输入详细描述', trigger: 'blur'},
                    ]
                },
                inputVisible: false,
                inputValue: ''
            }
        },
        created() {
            this.$emit('setIndex', [5, 3], '添加组织服务')
            this.id = Number(this.$route.params.id)
            if (this.id) this.init()
        },
        components: {},
        methods: {
            async init() {
                let _data = await getServerDetail(this.id)
                if (_data.status === 200) {
                    this.ruleForm = {
                        title: _data.data.title,
                        label: _data.data.label ? _data.data.label.split(',') : [],
                        desc: _data.data.desc,
                        childs: _data.data.son,
                    }
                }
            },
            submitForm(formName) {
                if (this.readonly) return this.readonly = false
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitChange();
                    }
                });
            },
            async submitChange() {
                this.loading = true
                let son_title =this.ruleForm.childs.map(item => {
                    return item.title
                })
                let son_content = this.ruleForm.childs.map((item) => {
                    return item.content
                })
                let son_id = this.id ? this.ruleForm.childs.map((item) => {
                    return item.id
                }) : ''
                let _data = await editServer(this.id,this.ruleForm.title, this.ruleForm.desc,
                    this.ruleForm.label,son_title, son_content,son_id)
                this.loading = false
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.$router.go(-1)
                }
            },
            handleClose(tag) {
                this.ruleForm.label.splice(this.ruleForm.label.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.ruleForm.label.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            addChild(){
                this.ruleForm.childs.push({
                    id:'',
                    title: '',
                    content: ''
                })
            },
            delChild(index){
                this.ruleForm.childs.splice(index, 1)
            }
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }

    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .service-list {
            background-color: #f3f7fb;
            border-radius: 10px;
            padding: 25px;
            margin-top: 20px;
            .item-title {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }
            .operate {
                width: 81px;
                height: 40px;
                line-height: 40px;
                padding: 0;
                border-radius: 20px;
                background: transparent;
                border: solid 1px #0a2240;
                font-size: 14px;
                color: #0a2240;
                cursor: pointer;
            }
        }
    }
</style>